import { api } from "./client";

// The team's task board and milestones (admin only).
export const TeamPlanAPI = {
  tasks: async () => {
    const { data } = await api.get("/api/admin/team/tasks");
    return Array.isArray(data) ? data : [];
  },

  createTask: async (task) => {
    const { data } = await api.post("/api/admin/team/tasks", task);
    return data;
  },

  updateTask: async (id, task) => {
    const { data } = await api.put(`/api/admin/team/tasks/${id}`, task);
    return data;
  },

  moveTask: async (id, status) => {
    const { data } = await api.patch(`/api/admin/team/tasks/${id}/status`, { status });
    return data;
  },

  deleteTask: async (id) => {
    await api.delete(`/api/admin/team/tasks/${id}`);
  },

  milestones: async () => {
    const { data } = await api.get("/api/admin/team/milestones");
    return Array.isArray(data) ? data : [];
  },

  createMilestone: async (milestone) => {
    const { data } = await api.post("/api/admin/team/milestones", milestone);
    return data;
  },

  updateMilestone: async (id, milestone) => {
    const { data } = await api.put(`/api/admin/team/milestones/${id}`, milestone);
    return data;
  },

  deleteMilestone: async (id) => {
    await api.delete(`/api/admin/team/milestones/${id}`);
  },
};
